import { FC } from 'react'
import imageResize from 'project/image-proxy-web'
import classNames from 'classnames'

interface Props {
  className?: string
}
const partnerLogos = [
  {
    alt: 'Tide Logo',
    src: '/images/logos/partners/tide.png',
  },
  {
    alt: 'Crunch Logo',
    src: '/images/logos/partners/crunch.png',
  },
  {
    alt: 'Osome Logo',
    src: '/images/logos/partners/osome.png',
  },
  {
    alt: 'Anna Logo',
    src: '/images/logos/partners/anna.png',
  },
  {
    alt: 'Black Dojo Logo',
    src: '/images/logos/partners/block-dojo.png',
  },
  {
    alt: 'Counting Up Logo',
    src: '/images/logos/partners/counting-up.png',
  },
  {
    alt: 'Ember Logo',
    src: '/images/logos/partners/ember.png',
  },
  {
    alt: 'Wow Logo',
    src: '/images/logos/partners/wow.png',
  },
  {
    alt: 'Cooper Parry Logo',
    src: '/images/logos/partners/cooper-parry.png',
  },
]

const TrustedPartners: FC<Props> = ({ className = 'pb-22' }) => {
  return (
    <div className='bg-grey6 mt-8'>
      <div className='container'>
        <div
          className={classNames(
            className,
            'px-6 px-md-0 pt-lg-12 pt-12 d-flex flex-column align-items-center',
          )}
        >
          <span className='fw-semibold partners-banner text-center text-grey5'>
            Trusted partnerships with financial institutions to reach over
            100,000 customers to date.
          </span>
          <div className='d-flex flex-wrap mt-10 justify-content-center align-items-center trusted-partners-gap'>
            {partnerLogos.map((logo) => (
              <img
                style={{
                  height: 'min-content',
                }}
                className='img-fluid'
                key={logo.alt}
                src={imageResize(logo.src)}
                alt={logo.alt}
                loading='lazy'
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TrustedPartners
